import { z } from 'zod';
import { currencySchema } from './project.js';
// Схема для создания/обновления плановой статьи
export const budgetLineSchema = z.object({
    category: z
        .string()
        .trim()
        .min(1, 'Название категории не может быть пустым')
        .max(100, 'Название категории слишком длинное (максимум 100 символов)')
        .regex(/^[\p{L}\p{N}\s\-–—()./]+$/u, 'Название категории может содержать только буквы, цифры, пробелы, дефисы, скобки и слэш'),
    amount: z.number().nonnegative(), // 0 разрешен (удалит строку)
    note: z.string().max(500).optional(),
});
// Схема для bulk-операции (массовое обновление всех категорий)
export const updateBudgetPlanSchema = z.object({
    lines: z.array(budgetLineSchema),
});
// Схема ответа - одна плановая статья
export const budgetLineResponseSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    category: z.string(),
    amount: z.number(),
    note: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
// Схема бюджетного плана (сводка)
export const budgetPlanSummarySchema = z.object({
    currency: currencySchema,
    budgetTotal: z.number().nullable(), // Общий лимит проекта
    area: z.number().nullable(), // Площадь проекта (м²)
    plannedTotal: z.number(), // Сумма всех плановых статей
    budgetLeft: z.number().nullable(), // Остаток = budgetTotal - plannedTotal
    isOverBudget: z.boolean(), // Превышен ли лимит
    percentUsed: z.number().nullable(), // % использования (plannedTotal / budgetTotal * 100)
    lines: z.array(budgetLineResponseSchema),
});
//# sourceMappingURL=budget.js.map